import React, { useContext, useState, useEffect } from "react";
import "./Dashboard.css";
import UserContext from "../../context/UserContext";
import { getDashboardDataCount } from "../../app/redux/slices/userManagement/userManagementSlice";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";
import activeUsersSvg from "../../assets/icons/active-users.svg"
import activeArticleSvg from "../../assets/icons/active-articles.svg"
import activeBlogSvg from "../../assets/icons/active-blog.svg"
import activeNewsletterSvg from "../../assets/icons/active-newsLetter.svg"
import totalSubscribersSvg from "../../assets/icons/total-subscribers.svg"
import addNewUserSvg from "../../assets/icons/new-user-add.svg"
import newArticlePublishSvg from "../../assets/icons/new-article-published.svg"
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { month: "Jan", users: 4500, articles: 2200 },
  { month: "Feb", users: 4800, articles: 2400 },
  { month: "Mar", users: 5600, articles: 3100 },
  { month: "Apr", users: 6500, articles: 4200 },
  { month: "May", users: 6800, articles: 4500 },
  { month: "Jun", users: 7800, articles: 5600 },
  { month: "Jul", users: 8400, articles: 6100 },
  { month: "Aug", users: 8300, articles: 5900 },
  { month: "Sep", users: 9100, articles: 6800 },
  { month: "Oct", users: 9800, articles: 7400 },
  { month: "Nov", users: 10400, articles: 8000 },
  { month: "Dec", users: 12200, articles: 9500 },
];


function Dashboard() {  
  const [AllCount, setAllCount] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getDashboardCount();
  }, []);

  const getDashboardCount = async () => {
    try {
      const res = await getDashboardDataCount();
      if (res?.data?.result > 0) {
        setAllCount(res?.data?.result_value)
      }
      setIsLoading(false)
    } catch (error) {
      console.log(error)
    }
  };


  return (
    <>
      {isLoading ? (<LoadingSpinner />) : (
        <>
        <div className="dashboard_details_card_wraper">
        <div className="dashboard_details_card">
          <div className="dashboard_details_card_inner_wraper">
            <div className="dashboard_details_card_img">
              <img
                src={activeUsersSvg}
                alt="Registered User"
              />
              <p>Users</p>
            </div>
            <div className="dashboard_card_requested_text">
              <span>{AllCount.totalUsers}</span>
              <p>Active Users</p>
            </div>
          </div>
        </div>
        <div className="dashboard_details_card">
          <div className="dashboard_details_card_inner_wraper">
            <div className="dashboard_details_card_img">
              <img
                src={activeArticleSvg}
                alt="Registered User"
              />
              <p>Article</p>
            </div>
            <div className="dashboard_card_requested_text">
              <span>{AllCount.totalArticle}</span>
              <p>Active Article</p>
            </div>
          </div>
        </div>
        <div className="dashboard_details_card">
          <div className="dashboard_details_card_inner_wraper">
            <div className="dashboard_details_card_img">
              <img
                src={activeBlogSvg}
                alt="Registered User"
              />
              <p>Blog</p>
            </div>
            <div className="dashboard_card_requested_text">
              <span>{AllCount.totalBlog}</span>
              <p>Active Blog</p>
            </div>
          </div>
        </div>
        <div className="dashboard_details_card">
          <div className="dashboard_details_card_inner_wraper">
            <div className="dashboard_details_card_img">
              <img
                src={activeNewsletterSvg}
                alt="Registered User"
              />
              <p>NewsLetter</p>
            </div>
            <div className="dashboard_card_requested_text">
              <span>{AllCount.totalNewsletter}</span>
              <p>Active NewsLetter</p>
            </div>
          </div>
        </div>
        <div className="dashboard_details_card">
          <div className="dashboard_details_card_inner_wraper">
            <div className="dashboard_details_card_img">
              <img
                src={totalSubscribersSvg}
                alt="Registered User"
              />
              <p>Newsletter Subscription</p>
            </div>
            <div className="dashboard_card_requested_text">
              <span>{AllCount.totalRegisteredEmail}</span>
              <p>Total Subscribers</p>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard-chart-main-wraper">
        <div className="dashboard-overview">
          <div className="tile-wraper">
            <div className="title-group">
              <h2>Content Overview</h2>
              <p className="subtitle">Monthly user and article growth</p>
            </div>
            <div className="legend">
              <div className="legend-item"><span className="dot purple"></span> Users</div>
              <div className="legend-item"><span className="dot blue"></span> Articles</div>
            </div>
          </div>
          <div style={{ width: "100%", height: 380 }}>
            <ResponsiveContainer>
              <AreaChart data={data}>

                {/* Gradients */}
                <defs>
                  <linearGradient id="usersGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#7C3AED" stopOpacity={0.4} />
                    <stop offset="100%" stopColor="#7C3AED" stopOpacity={0.05} />
                  </linearGradient>

                  <linearGradient id="articlesGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#0F172A" stopOpacity={0.4} />
                    <stop offset="100%" stopColor="#0F172A" stopOpacity={0.05} />
                  </linearGradient>
                </defs>

                {/* Grid */}
                <CartesianGrid
                  strokeDasharray="4 4"
                  vertical={false}
                  stroke="#CBD5E1"
                />

                {/* Axes */}
                <XAxis dataKey="month" />
                <YAxis
                  tickFormatter={(value) => `${value / 1000}k`}
                />

                {/* Tooltip & Legend */}
                <Tooltip />
                <Legend align="right" />

                {/* Users */}
                <Area
                  type="monotone"
                  dataKey="users"
                  stroke="#7C3AED"
                  strokeWidth={2.5}
                  fill="url(#usersGradient)"
                  dot={false}
                />

                {/* Articles */}
                <Area
                  type="monotone"
                  dataKey="articles"
                  stroke="#0F172A"
                  strokeWidth={2.5}
                  fill="url(#articlesGradient)"
                  dot={false}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="dashboard-overview">
          <div className="tile-wraper title-wraper2">
            <div className="title-group">
              <h2>Activity Feed</h2>
              <p className="subtitle">Recent activities</p>
            </div>
            <div className="legend">
              <span className="view-all">View All</span>
            </div>
          </div>
          <ul className="activity-list">
            <li className="activity-item">
              <div className="icon-box">
                 <img
                src={addNewUserSvg}
                alt="Registered User"
              />
              </div>
              <div className="activity-info">
                <p>New user registered: Ajay Singh</p>
                <span>2 min ago</span>
              </div>
            </li>
            <li className="activity-item">
              <div className="icon-box">
                 <img
                src={newArticlePublishSvg}
                alt="Registered User"
              />
              </div>
              <div className="activity-info">
                <p>New article published: Tech Trends 2024</p>
                <span>10 min ago</span>
              </div>
            </li>
            <li className="activity-item">
              <div className="icon-box">
                <img
                src={activeNewsletterSvg}
                alt="Registered User"
              />
              </div>
              <div className="activity-info">
                <p>Newsletter sent to 1,234 subscribers</p>
                <span>1 hour ago</span>
              </div>
            </li>
            <li className="activity-item">
              <div className="icon-box">
                 <img
                src={totalSubscribersSvg}
                alt="Registered User"
              />
              </div>
              <div className="activity-info">
                <p>New blog post created: AI Insights</p>
                <span>3 min ago</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      </>
)}
    </>
  );
}

export default Dashboard;
